import { useCallback, useMemo } from 'react';
import { usePersistentState } from './usePersistentState';

/**
 * Read-progress tracking (which articles are marked read). Replaces the
 * prototype's `readSet` localStorage array; exposes a `Set` + toggles.
 *
 * NOTE: progress is scoped per user (by email) so switching the mock user —
 * or wiring real auth later — keeps each person's progress separate.
 */
export function useProgress(userEmail: string) {
  const key = `lexidy-kb-read::${userEmail}`;
  const [readArr, setReadArr] = usePersistentState<string[]>(key, []);

  const read = useMemo(() => new Set(readArr), [readArr]);

  const toggleRead = useCallback(
    (id: string): boolean => {
      let added = false;
      setReadArr((prev) => {
        const next = new Set(prev);
        if (next.has(id)) {
          next.delete(id);
        } else {
          next.add(id);
          added = true;
        }
        return [...next];
      });
      return added;
    },
    [setReadArr],
  );

  const reset = useCallback(() => setReadArr([]), [setReadArr]);

  return { read, toggleRead, reset };
}
